import { render, staticRenderFns } from "./PriceField.vue?vue&type=template&id=25cb6847&scoped=true"
import script from "./PriceField.vue?vue&type=script&lang=js"
export * from "./PriceField.vue?vue&type=script&lang=js"
import style0 from "./PriceField.vue?vue&type=style&index=0&id=25cb6847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb6847",
  null
  
)

export default component.exports